import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  appBar: {
    backgroundColor: "#FFFFFF",
    boxShadow: "none"
  },

  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "64px",
    padding: "0 2%"
  },

  logoContainer: {
    display: "flex",
    alignItems: "center"
  },

  title: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "24px",
    fontWeight: 400,
    fontFamily: "sauna-new",
    color: "#009CA6",
    textAlign: "center",
    margin: 0
  },

  languageContainer: {
    display: "flex",
    alignItems: "center"
  },

  languageButton: {
    minWidth: 0,
    padding: 0,
    background: "none",
    border: "none",
    cursor: "pointer"
  },

  languageText: {
    marginLeft: "8px",
    fontSize: "16px",
    color: "#333",
    alignSelf: "center"
  }
};
